import DropdownContainer from "../../../Components/UiKits/Dropdown";

const Dropdown = () => {
  return <DropdownContainer />;
};

export default Dropdown;
